document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product-main-custom').forEach((section) => {
    const mainImage = section.querySelector('[data-gallery-image]');
    const thumbs = Array.from(section.querySelectorAll('[data-thumb]'));
    const prev = section.querySelector('[data-gallery-prev]');
    const next = section.querySelector('[data-gallery-next]');
    const zoomBtn = section.querySelector('[data-gallery-zoom]');

    const qtyInput = section.querySelector('[data-qty-input]');
    const minusBtn = section.querySelector('[data-qty-minus]');
    const plusBtn = section.querySelector('[data-qty-plus]');

    const variantIdInput = section.querySelector('[data-variant-id]');
    const priceEl = section.querySelector('[data-price]');
    const compareEl = section.querySelector('[data-compare-price]');
    const stockWrap = section.querySelector('.product-main-custom__stock');
    const stockText = section.querySelector('[data-stock-text]');
    const addToCartBtn = section.querySelector('[data-add-to-cart]');

    const optionInputs = Array.from(
      section.querySelectorAll('.product-main-custom__option-input')
    );

    const variantsJsonEl = section.querySelector('[data-product-json]');

    let variants = [];

    if (variantsJsonEl) {
      try {
        variants = JSON.parse(variantsJsonEl.textContent);
      } catch (error) {
        console.error('Could not read product variants:', error);
      }
    }

    let currentVariantPrice = 0;

    let currentImageIndex = thumbs.findIndex((thumb) =>
      thumb.classList.contains('is-active')
    );

    if (currentImageIndex < 0) {
      currentImageIndex = 0;
    }

    function formatMoney(cents) {
      const currency =
        window.Shopify &&
        window.Shopify.currency &&
        window.Shopify.currency.active
          ? window.Shopify.currency.active
          : 'GBP';

      const value = (Number(cents) || 0) / 100;

      return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency,
        minimumFractionDigits: Number.isInteger(value) ? 0 : 2,
        maximumFractionDigits: 2
      }).format(value);
    }

    function getSelectedAddOnsTotal() {
      let addOnsTotal = 0;

      section.querySelectorAll('.checkbor:checked').forEach((input) => {
        const addOnPrice = parseFloat(input.value || '0');

        if (!Number.isNaN(addOnPrice)) {
          addOnsTotal += Math.round(addOnPrice * 100);
        }
      });

      return addOnsTotal;
    }

    function updateDisplayedPrice() {
      if (!priceEl) return;

      const addOnsTotal = getSelectedAddOnsTotal();
      const totalPrice = currentVariantPrice + addOnsTotal;

      priceEl.textContent = formatMoney(totalPrice);
    }

    function setActiveImage(index) {
      if (!mainImage || !thumbs.length) return;

      currentImageIndex = (index + thumbs.length) % thumbs.length;

      const activeThumb = thumbs[currentImageIndex];

      const src =
        activeThumb.getAttribute('data-src') ||
        activeThumb.getAttribute('data-image-src');

      const alt =
        activeThumb.getAttribute('data-alt') ||
        activeThumb.getAttribute('data-image-alt') ||
        '';

      if (!src) return;

      mainImage.setAttribute('src', src);
      mainImage.setAttribute('alt', alt);

      thumbs.forEach((thumb) => {
        thumb.classList.remove('is-active');
      });

      activeThumb.classList.add('is-active');
    }

    function getSelectedOptions() {
      const selected = [];

      section
        .querySelectorAll('.product-main-custom__option-group')
        .forEach((group) => {
          const checked = group.querySelector(
            '.product-main-custom__option-input:checked'
          );

          if (checked) {
            selected.push(checked.value);
          }
        });

      return selected;
    }

    function findMatchedVariant() {
      if (!variants.length) return null;

      const selectedOptions = getSelectedOptions();

      return (
        variants.find((variant) => {
          return variant.options.every(
            (option, index) => option === selectedOptions[index]
          );
        }) || null
      );
    }

    function updateVariantUI(variant) {
      if (!variant) return;

      currentVariantPrice = Number(variant.price || 0);

      if (variantIdInput) {
        variantIdInput.value = variant.id;
      }

      updateDisplayedPrice();

      if (compareEl) {
        if (
          variant.compare_at_price &&
          variant.compare_at_price > variant.price
        ) {
          compareEl.textContent = formatMoney(
            variant.compare_at_price
          );

          compareEl.style.display = '';
        } else {
          compareEl.textContent = '';
          compareEl.style.display = 'none';
        }
      }

      if (stockWrap && stockText) {
        stockWrap.classList.toggle(
          'is-in-stock',
          Boolean(variant.available)
        );

        stockWrap.classList.toggle(
          'is-out-of-stock',
          !variant.available
        );

        stockText.textContent = variant.available
          ? 'In Stock'
          : 'Out of Stock';
      }

      if (addToCartBtn) {
        addToCartBtn.disabled = !variant.available;

        addToCartBtn.textContent = variant.available
          ? 'Add to Cart'
          : 'Sold Out';
      }

      if (variant.featured_image && mainImage) {
        const variantImageSrc =
          variant.featured_image.src ||
          variant.featured_image.url;

        if (variantImageSrc) {
          mainImage.setAttribute('src', variantImageSrc);

          const matchingThumbIndex = thumbs.findIndex((thumb) => {
            const thumbSrc =
              thumb.getAttribute('data-src') ||
              thumb.getAttribute('data-image-src') ||
              '';

            return (
              variant.featured_image.src &&
              thumbSrc.includes(variant.featured_image.src)
            );
          });

          if (matchingThumbIndex >= 0) {
            thumbs.forEach((thumb) => {
              thumb.classList.remove('is-active');
            });

            thumbs[matchingThumbIndex].classList.add('is-active');
            currentImageIndex = matchingThumbIndex;
          }
        }
      }
    }

    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', (event) => {
        event.preventDefault();
        setActiveImage(index);
      });
    });

    if (prev) {
      prev.addEventListener('click', (event) => {
        event.preventDefault();
        setActiveImage(currentImageIndex - 1);
      });
    }

    if (next) {
      next.addEventListener('click', (event) => {
        event.preventDefault();
        setActiveImage(currentImageIndex + 1);
      });
    }

    if (zoomBtn && mainImage) {
      zoomBtn.addEventListener('click', (event) => {
        event.preventDefault();
        window.open(mainImage.src, '_blank');
      });
    }

    if (minusBtn && qtyInput) {
      minusBtn.addEventListener('click', () => {
        qtyInput.value = Math.max(
          1,
          Number(qtyInput.value || 1) - 1
        );
      });
    }

    if (plusBtn && qtyInput) {
      plusBtn.addEventListener('click', () => {
        qtyInput.value = Number(qtyInput.value || 1) + 1;
      });
    }

    optionInputs.forEach((input) => {
      input.addEventListener('change', () => {
        const matchedVariant = findMatchedVariant();
        updateVariantUI(matchedVariant);
      });
    });

    section.addEventListener('change', (event) => {
      const target = event.target;

      if (
        target instanceof HTMLInputElement &&
        target.classList.contains('checkbor')
      ) {
        updateDisplayedPrice();
      }
    });

    const initialVariant = findMatchedVariant();

    if (initialVariant) {
      updateVariantUI(initialVariant);
    } else if (variants.length) {
      updateVariantUI(variants[0]);
    }
  });
});